import React from "react";
import { Box, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import StyleIcon from "@mui/icons-material/Style";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Link as LinkIcon } from "@mui/icons-material";
import WikipediaIcon from "./WikipediaIcon";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import YouTubeIcon from "@mui/icons-material/YouTube";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import GenerateIcon from "@mui/icons-material/AutoAwesome";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import SubjectIcon from "@mui/icons-material/Subject";
const SourceDisplay = ({ selectedSource, forTextlabbet, theme }) => {
  const getSourceInfo = () => {
    switch (selectedSource) {
      case "customTheme":
        return {
          icon: <EditIcon />,
          text: forTextlabbet ? "Ange din text" : "Egna instruktioner",
          subtitle: forTextlabbet
            ? "Skriv in texten du vill hantera"
            : "Beskriv innehållet du vill generera",
        };

      case "pasteText":
        return {
          icon: <SubjectIcon />,
          text: "Klistra in text",
          subtitle: "Klistra in hela din text som du vill använda",
        };

      case "vision":
        return {
          icon: <AddPhotoAlternateIcon />,
          text: "Ladda upp bild",
          subtitle: "Ladda upp en bild och analysera innehållet",
        };
      case "lessonBank":
        return {
          icon: <StyleIcon />,
          text: "Lektionsbank",
          subtitle: "Utforska färdiga lektioner",
        };
      case "fileUpload":
        return {
          icon: <FileUploadIcon />,
          text: "Ladda upp fil",
          subtitle: "Använd egen fil som underlag (.docx, .doc, .txt)",
        };
      case "url":
        return {
          icon: <WikipediaIcon />,
          text: "Artikel från Wikipedia",
          subtitle: "Hämta innehållet från valfri URL",
        };

      case "so-rummet":
        return {
          icon: (
            <Box
              component="img"
              src="/img/so-logga.png"
              alt="Skolverket"
              sx={{ width: 20, height: 20, objectFit: "contain" }}
            />
          ),
          text: "Artikel från SO-rummet",
          subtitle: "Hämta innehållet från valfri artikel från SO-rummet",
        };
      case "subject":
        return {
          icon: (
            <Box
              component="img"
              src="/img/skolverkets.jpg"
              alt="Skolverket"
              sx={{ width: 20, height: 20, objectFit: "contain" }}
            />
          ),
          text: "Skolverkets kursplan",
          subtitle: "Utgå från kursplanens innehåll",
        };
      case "wikipedia":
        return {
          icon: <WikipediaIcon />,
          text: "Wikipedia-artikel",
          subtitle: "Hämta innehållet från valfri Wikipedia-artikel",
        };
      case "predefined":
        return {
          icon: <AutoAwesomeIcon />,
          text: "Utvalda teman",
          subtitle: "Välj bland fördefinierade teman",
        };
      case "book":
        return {
          icon: (
            <Box
              component="img"
              src="/img/kulturradet-liten.png"
              alt="Kulturrådet"
              sx={{ width: 20, height: 20, objectFit: "contain" }}
            />
          ),
          text: "Kulturrådets läslistor",
          subtitle:
            "Utgå från rekommenderade böcker av Kulturrådet och Skolverket",
        };
      case "urplay":
        return {
          icon: (
            <Box
              component="img"
              src="/img/urplaysmall.png"
              alt="UR Play"
              sx={{ width: 20, height: 20, objectFit: "contain" }}
            />
          ),
          text: "UR Play",
          subtitle: "Använd UR Play-material",
        };
      case "youtube":
        return {
          icon: <YouTubeIcon />,
          text: "YouTube-video",
          subtitle: "Använd YouTube-video som underlag",
        };
      case "randomizer":
        return {
          icon: <ShuffleIcon />,
          text: "Slumpa ämne",
          subtitle: "Få ett slumpmässigt ämne",
        };
      default:
        return null;
    }
  };

  const sourceInfo = getSourceInfo();
  if (!sourceInfo) return null;

  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        gap: "12px",
        p: "16px",
        borderRadius: "0px",
        borderBottom:
          theme.palette.mode === "dark"
            ? " 1px solid #3e4954"
            : "1px solid #dbdbdc",
        margin: "-8px",
        mb: 2,
      }}
    >
      <Box
        sx={{
          color: "text.secondary",
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          "& > svg": {
            fontSize: "1.6rem",
          },
        }}
      >
        {sourceInfo.icon}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          component="span"
          sx={{
            fontSize: "15px",
            fontWeight: 500,
            color: "text.secondary",
            display: { xs: "none", md: "flex" },
            alignItems: "center",
          }}
        >
          {sourceInfo.text}
        </Typography>
        <Typography
          component="span"
          sx={{
            fontSize: "13px",
            color: "text.secondary",
            opacity: 0.8,
            display: "none",
          }}
        >
          {sourceInfo.subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default SourceDisplay;
